import React from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Languages, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import NotificationBell from "@/components/NotificationBell";
import GtLogo from "@/components/GtLogo";

export const TopBar = ({ title, onBack, showLang = true }) => {
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  const { lang, setLang, t } = useLang();
  return (
    <div className="sticky top-0 z-30 glass border-b border-white/40 px-4 sm:px-6 py-3 flex items-center justify-between" data-testid="topbar">
      <div className="flex items-center gap-3 min-w-0">
        {onBack ? (
          <button data-testid="back-btn" onClick={onBack} className="p-2 rounded-xl hover:bg-white/60 transition">
            <ArrowLeft className="w-5 h-5 text-[#1D1D1F]" />
          </button>
        ) : (
          <GtLogo size="w-10 h-10" />
        )}
        <div className="min-w-0">
          <div className="heading-font font-semibold text-[#1D1D1F] text-base sm:text-lg truncate" data-testid="topbar-title">{title}</div>
          {user && <div className="text-xs text-[#86868B] truncate">{user.name} • {user.role.replace("_", " ")}</div>}
        </div>
      </div>
      <div className="flex items-center gap-2">
        {user && <NotificationBell />}
        {showLang && (
          <button
            onClick={() => setLang(lang === "en" ? "ta" : "en")}
            className="px-3 py-2 rounded-xl hover:bg-white/60 transition flex items-center gap-1.5 text-sm font-semibold text-[#1D1D1F]"
            data-testid="lang-toggle"
          >
            <Languages className="w-4 h-4" />
            <span>{lang === "en" ? "தமிழ்" : "English"}</span>
          </button>
        )}
        <button
          onClick={logout}
          className="p-2 rounded-xl hover:bg-red-50 transition text-[#FF3B30]"
          data-testid="logout-btn"
          title={t("logout")}
        >
          <LogOut className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default TopBar;
